"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.search.placeholder': 'Search payments by session ID, description, email...',
};
